module.exports = __webpack_public_path__ + "img/DK.ddb56107.png";